import React from 'react';
import { Modal, Spin, Collapse, Tag } from 'antd';
import { UserOutlined, TeamOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const DashboardAccessModal = ({ visible, onClose, loading, groupedData, groupName }) => {
    return (
        <Modal
            title={`Acessos ao Setor: ${groupName}`}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={700}
        >
            {loading ? (
                <div className="flex justify-center py-8">
                    <Spin size="large" />
                </div>
            ) : (
                <Collapse accordion>
                    {groupedData.map((dashboard) => (
                        <Panel
                            header={
                                <div className="flex items-center justify-between">
                                    <span className="font-semibold">
                                        {dashboard.nome_dashboard}
                                    </span>
                                    <Tag color="blue">
                                        {dashboard.grupos.length} {dashboard.grupos.length === 1 ? 'grupo' : 'grupos'}
                                    </Tag>
                                </div>
                            }
                            key={dashboard.dashboard_id}
                        >
                            <Collapse ghost>
                                {dashboard.grupos.map((grupo) => (
                                    <Panel
                                        header={
                                            <div className="flex items-center gap-2">
                                                <TeamOutlined />
                                                <span className="font-medium text-blue-600">
                                                    {grupo.nome_grupo}
                                                </span>
                                                <Tag color="green">
                                                    {grupo.usuarios.length} {grupo.usuarios.length === 1 ? 'usuário' : 'usuários'}
                                                </Tag>
                                            </div>
                                        }
                                        key={grupo.grupo_id}
                                    >
                                        <ul className="ml-6 space-y-1">
                                            {grupo.usuarios.map((usuario, idx) => (
                                                <li key={idx} className="flex items-center gap-2 text-gray-700">
                                                    <UserOutlined className="text-gray-400" />
                                                    {usuario}
                                                </li>
                                            ))}
                                        </ul>
                                    </Panel>
                                ))}
                            </Collapse>
                        </Panel>
                    ))}
                </Collapse>
            )}
        </Modal>
    );
};

export default DashboardAccessModal;
